import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, CustomerDto, CustomerReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import CustomerInline, { CustomerInlineProps } from "./CustomerInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: CustomerDto | CustomerReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<CustomerInlineProps>;
}

export default function CustomerLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.CustomerRead]}
      to={ROUTE_PATH.CUSTOMER_VIEW(entity?.id || entityId || "")}
      content={
        <CustomerInline entity={entity} entityId={entityId} {...inlineProps} withTooltip={false} />
      }
      {...otherProps}
    />
  );
}
